<template>
  <section ref="collapse" :data-e2e="TaxCypressAttribute.finalTaxesCalculator.views.BREAKDOWN">
    <Collapse
      :show-icon="false"
      :is-borderless="true"
      :open="false"
      @open="setAsOpen"
      @close="setAsClose"
    >
      <template #header>
        <div class="is-full-width has-text-primary is-flex-centered">
          <span class="has-text-weight-semibold">
            {{ $t('tax.calculator-breakdown') }}
          </span>
          <div class="icon animate-icon m-t-2 m-l-5" :class="{ 'rotate-icon': isOpen }">
            <IconView pack="cls" size="is-small" custom-class="cls-caret-right" />
          </div>
        </div>
      </template>
      <template>
        <section ref="breakdown">
          <FinalTaxesLineItemRow
            v-for="(lineItemRow, index) in lineItems"
            :key="index"
            :line-item="lineItemRow"
          />
        </section>
      </template>
    </Collapse>
  </section>
</template>

<script>
import Collapse from '/@/modules/core/app/components/Collapse.vue';
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import FinalTaxesLineItemRow from '@/modules/tax/components/presentational/finaltaxescalculator/FinalTaxesLineItemRow.vue';
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesBreakDown',
  components: {
    IconView,
    FinalTaxesLineItemRow,
    Collapse
  },
  props: {
    lineItems: {
      type: Array
    }
  },
  static: {
    TaxCypressAttribute
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    setAsOpen() {
      this.isOpen = true;
      this.$nextTick(() => {
        this.$refs.breakdown?.scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
    },
    setAsClose() {
      this.isOpen = false;
      this.$nextTick(() => {
        this.$refs.collapse?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
};
</script>

<style scoped>
.animate-icon {
  transition: transform 0.3s ease;
}

.rotate-icon {
  transform: rotate(90deg);
}
</style>
